<template>
    <div class="login-dialog--login__content-container--text">
        <h2 class="login-dialog--login__content-container--text__title primary-font">{{ title }}</h2>
        <span class="login-dialog--login__content-container--text__subtitle secondary-font" :style="layout == 'portal' ? '' : 'color: #222222'">{{ description }}</span>
        <v-form>
          <v-text-field
            ref="identifierInput"
            autocomplete="email"
            type="email"
            :background-color="layout == 'portal' ? '' : 'var(--v-primary-opacity-12)'"
            color="primary"
            :class="layout == 'portal' ? 'portal-theme' : ''"
            class="login-dialog--login__content-container--text__input login-dialog--login__content-container--text__input--single" 
            v-model="identifier"
            :error-messages="error"
            @click="$emit('hasFocus')"
            @input="onInput"
            @keydown.enter="submit"
            placeholder="Mobilnummer / E-post">
          </v-text-field>
        </v-form>
</div>
</template>
<script>

export default {
  name: "the-identifier",
  props: {
      title: {
        required: true,
        default: ''
      },
      description: {
        required: true,
        default: ''
      },
      error: {
        required: false,
        default: '',
        type: String
      },
      layout: {
        required: false,
        default: 'chain',
        type: String
      }
    },
  components: {
    
  },
  data() {
    return {
     identifier: '',
    };
  },
  methods: {
    submit(event){
      event.preventDefault();
      this.onInput(event?.srcElement?._value)
      this.$emit("verify");
    },
    onInput(value) {
        this.$emit("setValue", value);
    },
  },
  mounted() {
    this.$nextTick(() => {
      setTimeout(() => {
        this.$refs.identifierInput.$refs.input.focus()
      })
    })
  }
};
</script>

<style lang="scss" scoped>
.portal-theme.theme--light.v-text-field:not(.v-input--has-state) {
  color: #579FA7 !important;
}
</style>